import React, { Component } from 'react';
import ManageWholesaler from '../../components/css/dark/img/theme-images/manage-distributor.svg';
import Popup from '../../components/Admin/ManageWholesaler';
import ManageGroup from '../../components/Admin/ManageGroup';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import $ from 'jquery';
import ManageUserPopup from '../../components/ManageUserAdmin';
import ManageGroupNumber from '../../components/Admin/ManageGroupPopup';
import Settings from '../../components/css/dark/img/theme-images/settings.svg';
import CreateGroup from '../../components/Admin/CreateGroup';
import ManageEmail from '../../components/Admin/ManageEmail';
import ChangePassword from '../../components/Admin/ChangePassword';
import DeleteUser from '../../components/Admin/DeleteUser';
import AddWholesaler from '../../components/Admin/AddWholesaler';
import EditProfile from '../../components/Admin/ManageProfile';
import WholesalerOverride from '../../components/Admin/WholesalerOverride';
import AdvanceSetting from '../../components/Admin/AdvanceSetting';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import BonusProgram from '../../components/Admin/BonusProgram';
import FindUser from '../../components/Admin/FindUser';
import Notification from '../../components/Admin/Notification';
import Search from '../../components/css/dark/img/theme-images/search.svg';
import Notify from '../../components/css/dark/img/notify_icon.svg';
import DynamicCommission from '../../components/Admin/DynamicCommission';
import CreateNotification from '../../components/Admin/CreateNotification';
import AddOverride from './AddOverride';
import GroupSection from '../../components/Admin/WhManageGroup';

class Tools extends Component {
    constructor(props) {
        super(props);
        try {
            this.state = {
                dashboardListRendered: false,
                dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
                WhshowPopup: false,
                userdata: JSON.parse(localStorage.getItem('user')),
                toggleWhPopup: false,
                ActiveJson: [],
                InActiveJson: [],
                istoggleManageUserPopup: false,
                iscalled: false,
                manageProfilePopup: false,
                createGroupPopup: false,
                manageGroupNumberPopup: false,
                findUserPopup: false,
                notificationPopup: false,
                createNotificationPopup: false,
                wholesalerId: '',
                wholesalerName: '',
                manageEmailPopup: false,
                changePasswordPopup: false,
                deleteUserPopup: false,
                dashboardId: '',
                wholesalerId: '',
                userName: '',
                userEmail: '',
                addWholesalerPopup: false,
                editProfilePopup: false,
                wholesalerOverridePopup: false,
                groupId: '',
                commission: '',
                wholesalerForPassword: '',
                changePasswordWholesaler: '',
                createGroupWhName: '',
                whPrefix: '',
                manageGroupPagin: '',
                manageEmailPagin: '',
                manageProfilePagin: '',
                backActivePagin: '',
                createGroupPagin: '',
                createGroupWhPagin: '',
                addWhActivePagin: '',
                backActiveManageGroup: '',
                whIsrule: '',
                whSearchText: '',
                backWhSearch: '',
                cGroupSearch: '',
                cGroupRule: '',
                overrideWhName: '',
                whEmail: '',
                advanceSettingPopup: false,
                checkGlic: '',
                DatePopup: false,
                dynamicCommissionPopup: false,
                BinData: '',
                dynamicData: '',
                isDynamic: false,
                notificationPage: 1,
                AddOverridePopup: false,
                manageGroupSection: false
            };
        }
        catch (error) { }
    }

    componentDidUpdate(prevProp) {
        if (this.state.ActiveJson.length == 0 && this.state.InActiveJson.length == 0 && this.state.iscalled == false ) {
            // this.GetRepsDetail();
        }
    }

    componentDidMount() {
       // document.title = 'Tools Page';
       // this.GetRepsDetail();
        $('body').addClass('admin');
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
        setTimeout(function () {
            const hasScrollbar = document.body.scrollHeight > window.innerHeight;
            if (!hasScrollbar) {
                $('body').addClass('hide-scroller');
            }
        }, 300);
    }
    componentWillUnmount() {
        $('body').removeClass('hide-scroller');
    }
    GetRepsDetail() {
        try {
            fetch('https://cnd.23byt.es/ws/Reps?wname=' + this.state.userdata.wholesaler)
                .then(response => response.json())
                .then(data => {
                    if (data != null && data.length > 0) {
                        this.setState({ ActiveJson: JSON.parse(data[0]["ActiveJson"]), InActiveJson: JSON.parse(data[0]["InactiveJson"]), iscalled: true });
                    }
                    else {
                        this.setState({ ActiveJson: [], InActiveJson: [], iscalled: true });
                    }
                });
        }
        catch (error) {
        }
    }

    toggleWhPopup(paging, searchText) {
        var wname = this.state.userdata.wholesaler;
        if (this.state.WhshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    WhshowPopup: !this.state.WhshowPopup,
                    dashboardName: wname,
                    backActivePagin: paging,
                    backWhSearch: searchText
                });
            }, 500)
        } else {
            this.setState({
                WhshowPopup: !this.state.WhshowPopup,
                dashboardName: wname,
                backActivePagin: paging,
                backWhSearch: searchText
            });
        }
    }
    toggleManageUserPopup() {
        this.setState({
            istoggleManageUserPopup: !this.state.istoggleManageUserPopup
        });
    }
    toggleManageGroupNumber() {
        if (this.state.manageGroupNumberPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    manageGroupNumberPopup: !this.state.manageGroupNumberPopup
                });
            }, 500)
        } else {
            this.setState({
                manageGroupNumberPopup: !this.state.manageGroupNumberPopup
            });
        }

    }    
    toggleChangePassword(wName, name, email) {
        this.setState({
            changePasswordPopup: !this.state.changePasswordPopup, changePasswordWholesaler: wName, userName: name, userEmail: email
        });
    }
    toggleDeleteUser(name, email) {
        this.setState({
            deleteUserPopup: !this.state.deleteUserPopup, userName: name, userEmail: email
        });
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $(".collapseButton").removeClass('active');
            });
            $(".tool-section").animate({
                marginLeft: 313 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".tool-section").animate({
                marginLeft: 133 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    manageProfile = (customerId, customerName, activeWhpagin, activePagin, isrule, whSearch) => {
        let currentId = customerId;
        let currentWholesaler = customerName;
        if (this.state.manageProfilePopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({ manageProfilePopup: !this.state.manageProfilePopup, wholesalerId: currentId, wholesalerName: currentWholesaler, backActiveManageGroup: activePagin, manageGroupPagin: activeWhpagin, whIsrule: isrule, whSearchText: whSearch });
            }, 500)
        } else {
            this.setState({ manageProfilePopup: !this.state.manageProfilePopup, wholesalerId: currentId, wholesalerName: currentWholesaler, backActiveManageGroup: activePagin, manageGroupPagin: activeWhpagin, whIsrule: isrule, whSearchText: whSearch });
        }
    }
    createGroup = (customerId, whName, activeWH, activeGroup, isrule, whSearch) => {
        let currentId = customerId;
        if (this.state.createGroupPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({ createGroupPopup: !this.state.createGroupPopup, cGroupRule: isrule, groupId: currentId, createGroupWhName: whName, createGroupWhPagin: activeWH, createGroupPagin: activeGroup, cGroupSearch: whSearch });
            }, 500)
        } else {
            this.setState({ createGroupPopup: !this.state.createGroupPopup, cGroupRule: isrule, groupId: currentId, createGroupWhName: whName, createGroupWhPagin: activeWH, createGroupPagin: activeGroup, cGroupSearch: whSearch });
        }
    }
    manageEmail = (customerId, whID, currentWholesaler, active, whSearch) => {
        if (this.state.manageEmailPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({ manageEmailPopup: !this.state.manageEmailPopup, dashboardId: customerId, wholesalerForPassword: currentWholesaler, wholesalerId: whID, manageEmailPagin: active, whSearchText: whSearch });
            }, 500)
        } else {
            this.setState({ manageEmailPopup: !this.state.manageEmailPopup, dashboardId: customerId, wholesalerForPassword: currentWholesaler, wholesalerId: whID, manageEmailPagin: active, whSearchText: whSearch });
        }
    }
    addWholesaler = (active) => {
        if (this.state.addWholesalerPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    addWholesalerPopup: !this.state.addWholesalerPopup,
                    addWhActivePagin: active
                });
            }, 50)
        } else {
            this.setState({
                addWholesalerPopup: !this.state.addWholesalerPopup,
                addWhActivePagin: active
            });
        }
    }
    editProfile = (customerName, customerId, customerprefix, active, whSearch, isDynamic) => {
        if (this.state.WhshowPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    isDynamic: isDynamic, editProfilePopup: !this.state.editProfilePopup, wholesalerName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch
                });
            }, 500)
        } else {
            this.setState({
                isDynamic: isDynamic, editProfilePopup: !this.state.editProfilePopup, wholesalerName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch
            });
        }
    }
    toggleOverridePopup = (customerName, customerId, customerprefix, active, whSearch, whEmail) => {
        if (this.state.wholesalerOverridePopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    wholesalerOverridePopup: !this.state.wholesalerOverridePopup,
                    overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
                });
            }, 500)
        } else {
            this.setState({
                wholesalerOverridePopup: !this.state.wholesalerOverridePopup,
                overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
            });
        }
    }
    toggleAddOverridePopup = (customerName, customerId, customerprefix, active, whSearch, whEmail) => {
        if (this.state.AddOverridePopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    AddOverridePopup: false
                });
            }, 500)
        } else {
            this.setState({
                AddOverridePopup: true
            });
        }
        this.setState({
            overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
        });
    }
    togglemanageGroupSection = (customerName, customerId, customerprefix, active, whSearch, whEmail, whId) => {
        if (this.state.manageGroupSection === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    manageGroupSection: false
                });
            }, 500)
        } else {
            this.setState({
                manageGroupSection: true
            });
        }
        this.setState({
            overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail, whId: whId
        });
    }
    toggleSettingPopup = (customerName, customerId, customerprefix, active, whSearch, whEmail, isGlic) => {
        if (this.state.advanceSettingPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    advanceSettingPopup: !this.state.advanceSettingPopup,
                    checkGlic: isGlic, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
                });
            }, 500)
        } else {
            this.setState({
                advanceSettingPopup: !this.state.advanceSettingPopup,
                checkGlic: isGlic, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
            });
        }
    }
    toggleDatePopup = (customerName, customerId, customerprefix, active, whSearch, whEmail, binData) => {
        if (this.state.DatePopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    DatePopup: !this.state.DatePopup,
                    BinData: binData, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
                });
            }, 500)
        } else {
            this.setState({
                DatePopup: !this.state.DatePopup,
                BinData: binData, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
            });
        }
    }
    dynamicPopup = (customerName, customerId, customerprefix, active, whSearch, whEmail, binData, dynamicCommission) => {
        if (this.state.dynamicCommissionPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    dynamicCommissionPopup: !this.state.dynamicCommissionPopup,
                    dynamicData: dynamicCommission, BinData: binData, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
                });
            }, 500)
        } else {
            this.setState({
                dynamicCommissionPopup: !this.state.dynamicCommissionPopup,
                dynamicData: dynamicCommission, BinData: binData, overrideWhName: customerName, wholesalerId: customerId, whPrefix: customerprefix, manageProfilePagin: active, whSearchText: whSearch, whEmail: whEmail
            });
        }
    }
    toggleFindUser = () => {
        if (this.state.findUserPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    findUserPopup: !this.state.findUserPopup
                });
            }, 500)
        } else {
            this.setState({
                findUserPopup: !this.state.findUserPopup
            });
        }
    }
    toggleNotification = (currentPage) => {
        if (this.state.notificationPopup === true) {
            $('.popup').removeClass('mfp-zoom-in');
            $('.popup').addClass('mfp-zoom-out');
            setTimeout(() => {
                this.setState({
                    notificationPopup: !this.state.notificationPopup,
                    notificationPage: currentPage
                });
            }, 500)
        } else {
            this.setState({
                notificationPopup: !this.state.notificationPopup,
                notificationPage: currentPage
            });
        }
    }
    toggleCreateNotification = (currentPage) => {
        this.setState({
            createNotificationPopup: !this.state.createNotificationPopup,
            notificationPage: currentPage
        });
    }    
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div>
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <Sidebar />
                <div className="tool-section">

                    <h2>Tools <span className="beta-link"><span className="beta">Beta</span></span></h2>
                    <ul>
                        <li onClick={this.toggleWhPopup.bind(this)}><div className="manage-content"><img src={ManageWholesaler} alt="" />Manage Wholesaler<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleManageGroupNumber.bind(this)}><div className="manage-content"><img src={Settings} alt="" />Manage Group Number<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleFindUser}><div className="manage-content"><img src={Search} alt="" />Find User<span className="arrow">&nbsp;</span></div></li>
                        <li onClick={this.toggleNotification}><div className="manage-content"><img src={Notify} alt="" />Manage Notifications<span className="arrow">&nbsp;</span></div></li>
                        {/*<li onClick={this.toggleManageUserPopup.bind(this)}><div className="manage-content"><img src={Settings} alt="" />Manage Wholesaler Account<span className="arrow">&nbsp;</span></div></li>*/}
                    </ul>
                    {
                        this.state.createNotificationPopup ?
                            <CreateNotification cPage={this.state.notificationPage} text='Create New Notification' OpenNotification={this.toggleNotification} closeCreateNotification={this.toggleCreateNotification} /> : null
                    }
                    {
                        this.state.notificationPopup ?
                            <Notification cPage={this.state.notificationPage} text='Manage Notifications' openCreateNotification={this.toggleCreateNotification} closeNotification={this.toggleNotification} /> : null
                    }
                    {
                        this.state.findUserPopup ?
                            <FindUser text='Find User' closeFindUser={this.toggleFindUser} /> : null
                    }
                    {
                        this.state.WhshowPopup ?
                            <Popup closeAddWholesalerPopup={this.addWholesaler.bind(this)} backSearch={this.state.backWhSearch} backActivePagin={this.state.backActivePagin} closeEditProfilePopup={this.editProfile.bind(this)} manageGroupPopup={this.manageProfile} manageEmailPopup={this.manageEmail} text='Manage Wholesaler' wholesaler_name={this.state.dashboardName} closePopup={this.toggleWhPopup.bind(this)} /> : null
                    }
                    {
                        this.state.istoggleManageUserPopup ?
                            <ManageUserPopup text='Manage Wholesaler Account' calldata={"callonce"} closePopup={this.toggleManageUserPopup.bind(this)} /> : null
                    }
                    {
                        this.state.manageProfilePopup ?
                            <ManageGroup openGroupPopup={this.createGroup} whSearch={this.state.whSearchText} whIsRule={this.state.whIsrule} backActivePagin={this.state.backActiveManageGroup} titleText='Wholesaler' whName={this.state.createGroupWhName} wholesalerId={this.state.groupId} activePagin={this.state.manageGroupPagin} openWholesalerPopup={this.toggleWhPopup.bind(this)} dataId={this.state.wholesalerId} wholesalerName={this.state.wholesalerName} closeManageGroupPopup={this.manageProfile.bind(this)} /> : null
                    }
                    {
                        this.state.createGroupPopup ?
                            <CreateGroup titleText='Create Group Numbers' whRule={this.state.cGroupRule} whSearch={this.state.cGroupSearch} activeWhPagin={this.state.createGroupWhPagin} activePagin={this.state.createGroupPagin} whName={this.state.createGroupWhName} wholesalerId={this.state.groupId} openManageGroupPopup={this.manageProfile.bind(this)} closeCreateGroupPopup={this.createGroup.bind(this)} /> : null
                    } 
                    {
                        this.state.manageEmailPopup ?
                            <ManageEmail titleText='Wholesaler User' whSearch={this.state.whSearchText} activePagin={this.state.manageEmailPagin} openWholesalerPopup={this.toggleWhPopup.bind(this)} wholesalerId={this.state.wholesalerId} wholesalerName={this.state.wholesalerForPassword} closeDeleteUserPopup={this.toggleDeleteUser.bind(this)} closeResetPasswordPopup={this.toggleChangePassword.bind(this)} dataId={this.state.dashboardId} closePopup={this.manageEmail.bind(this)} /> : null
                    }
                    {
                        this.state.changePasswordPopup ?
                            <ChangePassword titleText='Change Password' activeManageEmailPagin={this.state.manageEmailPagin} wholesalerId={this.state.wholesalerId} wholesalerName={this.state.wholesalerForPassword} userName={this.state.userName} userEmail={this.state.userEmail} dataId={this.state.dashboardId} openManageEmailPopup={this.manageEmail.bind(this)} closeResetPasswordPopup={this.toggleChangePassword.bind(this)} /> : null
                    }
                    {
                        this.state.deleteUserPopup ?
                            <DeleteUser titleText='Are you sure want to delete this user' activeManageEmailPagin={this.state.manageEmailPagin} wholesalerId={this.state.wholesalerId} wholesalerName={this.state.wholesalerForPassword} userName={this.state.userName} userEmail={this.state.userEmail} dataId={this.state.dashboardId} openManageEmailPopup={this.manageEmail.bind(this)} closeDeleteUserPopup={this.toggleDeleteUser.bind(this)} /> : null
                    }
                    {
                        this.state.addWholesalerPopup ?
                        <AddWholesaler titleText='New Wholesaler' activePagin={this.state.addWhActivePagin} openWholesalerPopup={this.toggleWhPopup.bind(this)} closeAddWholesalerPopup={this.addWholesaler.bind(this)} /> : null
                    }
                    {
                        this.state.editProfilePopup ?
                            <EditProfile isDynamic={this.state.isDynamic} dynamicCommission={this.dynamicPopup.bind(this)} closeDatePopup={this.toggleDatePopup.bind(this)} titleText='New Wholesaler' openSettingPopup={this.toggleSettingPopup.bind(this)} openOverridePopup={this.toggleOverridePopup.bind(this)} openAddOverridePopup={this.toggleAddOverridePopup.bind(this)} whSearch={this.state.whSearchText} activePagin={this.state.manageProfilePagin} openWholesalerPopup={this.toggleWhPopup.bind(this)} whPrefix={this.state.whPrefix} commission={this.state.commission} wholesalerId={this.state.wholesalerId} wholesaler_name={this.state.wholesalerName} closeEditProfilePopup={this.editProfile.bind(this)} /> : null
                    }
                    {
                        this.state.manageGroupNumberPopup ?
                            <ManageGroupNumber text='Manage Group Numbers' wholesaler_name='Admin' closePopup={this.toggleManageGroupNumber.bind(this)} /> : null
                    }
                    {
                        this.state.wholesalerOverridePopup ?
                            <WholesalerOverride whEmail={this.state.whEmail} whName={this.state.overrideWhName} whId={this.state.wholesalerId} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} openEditProfilePopup={this.editProfile.bind(this)} text={this.state.overrideWhName} closeOverridePopup={this.toggleOverridePopup.bind(this)} /> : null
                    }
                    {
                        this.state.AddOverridePopup ?
                            <AddOverride whName={this.state.overrideWhName} whId={this.state.wholesalerId} closeAddOverridePopup={this.toggleAddOverridePopup.bind(this)} openEditProfilePopup={this.editProfile.bind(this)} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} text={`Manage Chain List: ${this.state.wholesalerName}`} openmanageGroupSection={this.togglemanageGroupSection.bind(this)} /> : null
                    }
                    {
                        this.state.manageGroupSection ?
                            <GroupSection whName={this.state.overrideWhName} whId={this.state.wholesalerId} closemanageGroupSection={this.togglemanageGroupSection.bind(this)} openAddOverridePopup={this.toggleAddOverridePopup.bind(this)} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} text={`Manage Chain List: ${this.state.wholesalerName}`} /> : null
                    }
                    {
                        this.state.advanceSettingPopup ?
                            <AdvanceSetting isGlic={this.state.checkGlic} whEmail={this.state.whEmail} whName={this.state.overrideWhName} whId={this.state.wholesalerId} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} titleText={'Advance Settings'} openEditProfilePopup={this.editProfile.bind(this)} closeSettingPopup={this.toggleSettingPopup.bind(this)} /> : null
                    }
                    {
                        this.state.DatePopup ?
                            <BonusProgram openEditProfilePopup={this.editProfile.bind(this)} titleText={'Bonus Program'} binData={this.state.BinData} whEmail={this.state.whEmail} whName={this.state.overrideWhName} whId={this.state.wholesalerId} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} closeDatePopup={this.toggleDatePopup.bind(this)} /> : null
                    }
                    {
                        this.state.dynamicCommissionPopup ?
                            <DynamicCommission openEditProfilePopup={this.editProfile.bind(this)} dynamicData={this.state.dynamicData} titleText={'Dynamic User Commission'} binData={this.state.BinData} whEmail={this.state.whEmail} whName={this.state.overrideWhName} whId={this.state.wholesalerId} whPrefix={this.state.whPrefix} whProfilePagin={this.state.manageProfilePagin} whSearch={this.state.whSearchText} closeDynamicPopup={this.dynamicPopup.bind(this)} /> : null
                    }
                </div>
            </div>
        )
    }
}
export default Tools;